import React from "react";
import SectionFeature from "../sections-sections/SectionFeature.js"
import FooterBlack from "components/Footers/FooterBlack.js";
// sections for this page
// reactstrap components
import Particles from "components/Particles.js";

// core components
import InfoNavbar from "components/Navbars/InfoNavbar";
import Buttons from "components/Headers/Buttons.js";
import "./about.css";

function AboutUs() {
 
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <InfoNavbar />
      <br/>
   <Buttons />
   <div style={{height:"3px", backgroundColor: "gold"}} />
 
      <SectionFeature/>
      <Particles/>

      <FooterBlack />

    </>
  );
}

export default AboutUs;
